import React, { useState } from "react";
import { useAuth } from "../../contexts/authContexts";
import Icon from "@mdi/react";
import { mdiAlertCircleOutline, mdiLogin, mdiShieldLockOutline } from "@mdi/js";
import { theme } from "../../theme/colors";
import "./Login.css";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { login, fetchUser } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!email.trim() || !password) {
            setError("Por favor, completa todos los campos.");
            return;
        }

        setIsLoading(true);

        try {
            const result = await login(email.trim(), password);
            if (result === true) {
                await fetchUser();
            } else {
                setError(typeof result === "string" ? result : "Credenciales inválidas.");
            }
        } catch (e) {
            setError("Error en el inicio de sesión. Intenta nuevamente.");
            console.error(e.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-page" style={{ background: theme.gradient }}>
            <div className="login-page__glow login-page__glow--top" aria-hidden="true" />
            <div className="login-page__glow login-page__glow--bottom" aria-hidden="true" />

            <div className="login-card">
                <div className="login-card__icon" aria-hidden="true">
                    <Icon path={mdiShieldLockOutline} size={1.5} color="#fff" />
                </div>

                <h1 className="login-card__title">Bienvenido</h1>
                <p className="login-card__subtitle">Ingresa tus credenciales para continuar</p>

                <form onSubmit={handleSubmit} className="space-y-4" noValidate>
                    <div className="login-field">
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="email"
                            disabled={isLoading}
                            required
                        />
                        <label htmlFor="email">Correo electrónico</label>
                    </div>

                    <div className="login-field">
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            disabled={isLoading}
                            required
                        />
                        <label htmlFor="password">Contraseña</label>
                    </div>

                    <button type="submit" className="login-submit" disabled={isLoading}>
                        {isLoading ? (
                            <>
                                <span className="login-spinner" aria-hidden="true" />
                                Ingresando...
                            </>
                        ) : (
                            <>
                                <Icon path={mdiLogin} size={1.1} />
                                Iniciar sesión
                            </>
                        )}
                    </button>
                </form>

                <div className="login-footer">
                    <a href="#" onClick={(e) => e.preventDefault()}>
                        ¿Olvidó contraseña?
                    </a>
                    <label className="login-remember" htmlFor="default_remember">
                        <input id="default_remember" type="checkbox" disabled={isLoading} />
                        Recordarme
                    </label>
                </div>

                {error && (
                    <div className="login-error" role="alert">
                        <Icon path={mdiAlertCircleOutline} size={0.9} />
                        <span>{error}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Login;
